import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";

//Permissions
import Permission from './permission/reducer';

//Member
import Member from './member/reducer';

// Regionals
import Regionals from "./regionals/reducer";

// Observer
import Observer from "./observer/reducer";

const rootReducer = combineReducers({
    // public
    Layout,
    Login,
    Permission,
    Member,
    Regionals,
    Observer,
});



export default rootReducer;
